export const AlertType = {
    ALERT: "alert",
    CONFIRM: "confirm"
}

export const AlertVariant = {
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    INFORMATION: "information",
    NEUTRAL: "neutral"
}

export const DEFAULT_ALERT_CONFIG = {
    type: AlertType.ALERT,
    options: {
        variant: AlertVariant.NEUTRAL,
        title: "",
        text: "",
        okLabel: "",
        cancelLabel: "",
    },
    onOkClick: null,
    onCancelClick: null
};
